import React from "react";

const AdminUsersComponent = props => {

    return(
   <>
       AdminUsersComponent
    </>
    );
}

AdminUsersComponent.defaultProps = {

}
AdminUsersComponent.propTypes = {

}

export default (AdminUsersComponent);